export const COOKIE_DP = 'dp-app';
export const LOCALSTORAGE_USER = 'USER';
export const ACCESS_DEMAND_PLANNING_ROLE = 'access-demand-planning';

export const QUERY_KEY_SKU_DETAIL = 'sku-detail';
export const QUERY_KEY_SKU_FORECAST_DATA = 'sku-forecast-data';
export const QUERY_KEY_FORECAST_SESSIONS = 'forecast-sessions';
export const QUERY_KEY_OPEN_SESSION_FORECAST_DATA =
  'open-session-forecast-data';
export const QUERY_KEY_OPEN_SESSION_CRITERIA = 'open-session-criteria';
export const QUERY_KEY_OPEN_SESSION_PRODUCTS = 'open-session-products';
export const QUERY_KEY_SCOPE_PURCHASE_PRODUCTS = 'scope-purchase-products';
export const QUERY_KEY_NOVELTIES_BEST_CANDIDATES = 'noveltiesBestCandidates';

export const getForecastSessionsQueryKey = (status: string = 'open') => [
  QUERY_KEY_FORECAST_SESSIONS,
  status,
];
export const getSessionForecastDataQueryKey = (
  sessionId: string,
  page: number,
) => [QUERY_KEY_OPEN_SESSION_FORECAST_DATA, sessionId, page];

export const getSessionForecastDataQueryPrefix = (sessionId: string) => [
  QUERY_KEY_OPEN_SESSION_FORECAST_DATA,
  sessionId,
];
export const getSessionCriteriaQueryKey = (sessionId: string) => [
  QUERY_KEY_OPEN_SESSION_CRITERIA,
  sessionId,
];
export const getSessionProductsQueryKey = (sessionId: string) => [
  QUERY_KEY_OPEN_SESSION_PRODUCTS,
  sessionId,
];
